import React, { Component } from 'react';
import { Container, Segment, Label, Table, Button, Dropdown, Input, Popup, Icon, Message, Divider } from 'semantic-ui-react';
import AutoNumeric from 'autonumeric';
import { validateOfficer, validateNonOfficer } from './validations';
import { get, del, post, put } from '../../services/RestUtilities';

class ClassesAndWages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            numberOfRowsToAdd: '',
            applicableClasses: []
        }
    }

    componentDidMount() {
        // Non Officers
        if (this.props.nonOfficers.length === 0) {
            fetch(`api/Application/GetApplicableClassesForNonOfficers?coverageId=${this.props.coverageId}`)
                .then((response) => response.json())
                .then(data => {
                    this.props.setNonOfficers(data);
                });
        }
        // Officers
        if (this.props.officers.length === 0 && !this.props.applicationId) {
            this.props.setOfficers([
                {
                    id: 1,
                    officerName: '',
                    classCode: '',
                    wagePaid: '',
                    hoursWorked: '520',
                    errorMessage: '',
                }
            ]);
        }

        get(`api/Application/GetApplicableClassesForOfficers?coverageId=${this.props.coverageId}`)
            .then((response) => {
                if (!response.isError) {
                    this.setState({ applicableClasses: response.content });
                }
            });
    }

    componentDidUpdate() {
        let wageInputs = document.querySelectorAll('.wage-input > input');
        if (wageInputs.length > 0) {
            AutoNumeric.multiple('.wage-input:not(.formatted) > input', { currencySymbol: '$', decimalPlaces: 0 });
            var mostRecentlyAddedInputs = document.querySelectorAll('.wage-input:not(.formatted)');
            for (var i = 0; i < mostRecentlyAddedInputs.length; i++) {
                mostRecentlyAddedInputs[i].classList.add('formatted');
            }
        }
    }

    render() {
        const { nonOfficers, maxNonOfficerRate, extremeWage, officers, maxOfficerRate, minOfficerRate, readOnly } = this.props;
        const classOptions = getClassOptions(this.state.applicableClasses);

        return (
            <Segment>
                <Label ribbon color='green' content='Enter class & wage information:' />
                <Container>
                    <Label pointing='below' color='olive' content='For NON-OFFICERS:' />
                    <span> Enter '0' if no wages and hours apply to a class code.</span>
                    <NonOfficerTable
                        onNonOfficerTableUpdate={this.props.onNonOfficerTableUpdate}
                        nonOfficers={nonOfficers}
                        maxNonOfficerRate={maxNonOfficerRate}
                        extremeWage={extremeWage}
                        readOnly={readOnly}
                    />
                    <Message info icon='bullhorn' content='Officers are to be excluded from the Non-Officers.' />
                </Container>
                <Divider />
                <Container>
                    <Label pointing='below' color='olive' content='For OFFICERS:' />
                    <span> If there are no officers to report, remove the row by clicking the (-) sign to the left.</span>
                    <Input
                        style={{ float: 'right' }}
                        className='officer-add-number-of-rows'
                        action={<Button icon='plus' inverted color='green' onClick={() => this.handleAddRow(this.state.numberOfRowsToAdd)} disabled={readOnly} />}
                        placeholder='Add rows'
                        onChange={this.handleNumberOfRowsToAddChange}
                        value={this.state.numberOfRowsToAdd}
                        disabled={readOnly}
                    />
                    <OfficerTable
                        onOfficerTableUpdate={this.props.onOfficerTableUpdate}
                        officers={officers}
                        classOptions={classOptions}
                        onDelete={this.handleDeleteRow}
                        maxOfficerRate={maxOfficerRate}
                        minOfficerRate={minOfficerRate}
                        readOnly={readOnly}
                    />
                    <Button content='Add new officer' color='green' inverted onClick={() => this.handleAddRow(1)} disabled={readOnly} />
                </Container>
            </Segment>
        );
    }

    // #region Officer Event Handlers
    handleNumberOfRowsToAddChange = (e) => {
        const numberOfRowsNumberRegex = /^[0-9\b]+$/;
        if (e.target.value === '' || numberOfRowsNumberRegex.test(e.target.value)) {
            this.setState({ numberOfRowsToAdd: e.target.value });
        }
    }

    handleAddRow = (numberOfRows) => {
        for (let i = 0; i < numberOfRows; i++) {
            const id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
            const officer = {
                id: id,
                officerName: '',
                classCode: '',
                wagePaid: '',
                hoursWorked: '520',
                errorMessage: '',
            };
            this.props.officers.push(officer);
        }
        this.props.setOfficers(this.props.officers);
    }

    handleDeleteRow = (officer) => {
        const index = this.props.officers.indexOf(officer);
        this.props.officers.splice(index, 1);
        this.props.setOfficers(this.props.officers);
    }
    // #endregion Officer Event Handlers 
}

const getClassOptions = (classList) => {
    let options = [];

    var uniqueClasses = classList.filter((v, i, a) => a.indexOf(v) === i);
    for (let i = 0; i < uniqueClasses.length; i++) {
        options.push({ key: uniqueClasses[i], value: uniqueClasses[i], text: uniqueClasses[i] });
    }

    return options;
}

// #region NonOfficer Table
const NonOfficerTable = props => (
    <Table striped>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>Company Name</Table.HeaderCell>
                <Table.HeaderCell>Class Code</Table.HeaderCell>
                <Table.HeaderCell>Wage Paid</Table.HeaderCell>
                <Table.HeaderCell>Hours Worked</Table.HeaderCell>
                <Table.HeaderCell>Valid</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {props.nonOfficers.map(nonOfficer => (
                <NonOfficerRow
                    key={nonOfficer.id}
                    nonOfficer={nonOfficer}
                    onNonOfficerTableUpdate={props.onNonOfficerTableUpdate}
                    maxNonOfficerRate={props.maxNonOfficerRate}
                    extremeWage={props.extremeWage}
                    readOnly={props.readOnly}
                />
            ))}
        </Table.Body>
    </Table>
);

const NonOfficerRow = props => {
    const { maxNonOfficerRate, readOnly, extremeWage } = props;
    const validationResponse = validateNonOfficer(props.nonOfficer.wagePaid, props.nonOfficer.hoursWorked, maxNonOfficerRate, extremeWage);

    let validMark;
    if (validationResponse.result) {
        validMark = (<Icon name='check' color='green' inverted circular />);
    } else if (validationResponse.severity === 'FATAL') {
        validMark = (
            <Popup
                trigger={<Icon name='exclamation' color='red' inverted circular />}
                content={validationResponse.errorMessage}
            />
        );
    } else {
        validMark = (
            <Popup
                trigger={<Icon name='exclamation triangle' color='orange' inverted circular />}
                content={validationResponse.errorMessage}
            />
        );
    }

    return (
        <Table.Row>
            <Table.Cell width={5}>{props.nonOfficer.insuredName}</Table.Cell>
            <Table.Cell width={3}>{props.nonOfficer.classCode}</Table.Cell>
            <NonOfficerEditableCell
                placeholder='$99,999'
                className='wage-input'
                onNonOfficerTableUpdate={props.onNonOfficerTableUpdate}
                cellData={{
                    name: 'wagePaid',
                    value: props.nonOfficer.wagePaid,
                    id: props.nonOfficer.id
                }}
                readOnly={readOnly}
            />
            <NonOfficerEditableCell
                placeholder='999'
                onNonOfficerTableUpdate={props.onNonOfficerTableUpdate}
                cellData={{
                    name: 'hoursWorked',
                    value: props.nonOfficer.hoursWorked,
                    id: props.nonOfficer.id
                }}
                readOnly={readOnly}
            />
            <Table.Cell>
                {validMark}
            </Table.Cell>
        </Table.Row>
    );
};

const NonOfficerEditableCell = props => (
    <Table.Cell width={4}>
        <Input
            placeholder={props.placeholder}
            fluid
            className={props.className}
            onChange={props.onNonOfficerTableUpdate}
            name={props.cellData.name}
            id={props.cellData.id}
            value={props.cellData.value}
            disabled={props.readOnly}
        />
    </Table.Cell>
);
// #endregion Table

// #region Officer Table
const OfficerTable = props => (
    <Table striped>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>Officer Name</Table.HeaderCell>
                <Table.HeaderCell>Class Code</Table.HeaderCell>
                <Table.HeaderCell>Wage Paid</Table.HeaderCell>
                <Table.HeaderCell>Hours Worked</Table.HeaderCell>
                <Table.HeaderCell>Valid</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
        <Table.Body>
            {props.officers.map(officer => (
                <OfficerRow
                    key={officer.id}
                    officer={officer}
                    onOfficerTableUpdate={props.onOfficerTableUpdate}
                    classOptions={props.classOptions}
                    onDelete={props.onDelete}
                    maxOfficerRate={props.maxOfficerRate}
                    minOfficerRate={props.minOfficerRate}
                    readOnly={props.readOnly}
                />
            ))}
        </Table.Body>
    </Table>
);

class OfficerRow extends Component {

    handleDeleteEvent = () => {
        this.props.onDelete(this.props.officer)
    }

    render() {
        const { officer, maxOfficerRate, minOfficerRate, readOnly } = this.props;
        const validationResponse = validateOfficer(officer.officerName,
            officer.classCode,
            officer.wagePaid,
            officer.hoursWorked,
            maxOfficerRate,
            minOfficerRate);

        let validMark;
        if (validationResponse.result) {
            validMark = (<Icon name='check' color='green' inverted circular />);
        } else {
            validMark = (
                <Popup
                    trigger={<Icon name='exclamation' color='red' inverted circular />}
                    content={validationResponse.errorMessage}
                />
            );
        }

        return (
            <Table.Row>
                <Table.Cell>
                    <Popup trigger={<Button inverted circular icon='minus' color='red' size='mini' onClick={this.handleDeleteEvent} disabled={readOnly} />} content='Delete row' />
                </Table.Cell>
                <OfficerEditableCell
                    type='input'
                    placeholder='Officer Name'
                    onOfficerTableUpdate={this.props.onOfficerTableUpdate}
                    cellData={{
                        name: 'officerName',
                        value: officer.officerName,
                        id: officer.id
                    }}
                    readOnly={readOnly}
                />
                <OfficerEditableCell
                    type='dropdown'
                    options={this.props.classOptions}
                    placeholder='Class'
                    onOfficerTableUpdate={this.props.onOfficerTableUpdate}
                    cellData={{
                        name: 'classCode',
                        value: officer.classCode,
                        id: officer.id
                    }}
                    readOnly={readOnly}
                />
                <OfficerEditableCell
                    type='input'
                    placeholder='$99,999'
                    className='wage-input'
                    onOfficerTableUpdate={this.props.onOfficerTableUpdate}
                    cellData={{
                        name: 'wagePaid',
                        value: officer.wagePaid,
                        id: officer.id
                    }}
                    readOnly={readOnly}
                />
                <Table.Cell width={4}>
                    <Input
                        fluid
                        name='hoursWorked'
                        value={officer.hoursWorked}
                        disabled={readOnly}
                    />
                </Table.Cell>
                <Table.Cell>
                    {validMark}
                </Table.Cell>
            </Table.Row>
        );
    }
}

const OfficerEditableCell = props => {
    if (props.type === 'dropdown') {
        return (
            <Table.Cell width={4}>
                <Dropdown
                    placeholder={props.placeholder}
                    fluid
                    search
                    selection
                    options={props.options}
                    name={props.cellData.name}
                    id={props.cellData.id}
                    value={props.cellData.value}
                    onChange={props.onOfficerTableUpdate}
                    disabled={props.readOnly}
                />
            </Table.Cell>
        );
    } else {
        return (
            <Table.Cell width={4}>
                <Input
                    placeholder={props.placeholder}
                    fluid
                    className={props.className}
                    name={props.cellData.name}
                    id={props.cellData.id}
                    value={props.cellData.value}
                    onChange={props.onOfficerTableUpdate}
                    disabled={props.readOnly}
                />
            </Table.Cell>
        );
    }
};

// #endregion Officer Table

export default ClassesAndWages;